<main class="unclaim-devices-page" *ngIf = "pageContent" >
    <h1 class="pageHeading"><strong> {{pageContent.heading}} </strong></h1>
    <div *ngIf="showError" id="alertMessage" class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Alert.">
            <i class="icon-badgealert"></i>
        </div>
        <div>
            <span>{{pageContent.errorMessage}}</span>
        </div>
    </div>
<div class="select-wrapper">
    <div *ngIf="gridOptions && FANList.length === 0">
        <h2>{{pageContent.noFans}}</h2>
    </div>
    <div *ngIf="FANList.length > 0">
        <!-- <h2> {{prodcode}} </h2> -->
         <!-- <h2>{{ prodcode === 'Apple Business Manager' ? 'Apple Business' : prodcode }}</h2> -->
          <h2>{{
                prodcode === 'Apple Business Manager'
                ? 'Apple Business'
                : (prodcode === 'Samsung Knox Mobile'
                    ? 'Samsung Knox Mobile Enrollment'
                    : prodcode)
            }}</h2>
        <div class="explText">
            <p> {{pageContent.subhead}} </p>
            <h4 class="note"><strong>{{pageContent.note}}</strong></h4>
            <ul>
                <li id="point1">{{pageContent.note1}}</li>
                <li id="point2">{{pageContent.note2}}</li>
            </ul>
            <p> {{pageContent.subhead1}} </p>
        </div>
        <app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
        <p><strong> {{pageContent.selectedFans}}</strong></p>
        <div class="row">
            <div class="col-sm-12 col-md-12 text-right buttons-section">
                <button (click)="unclaimReviewPage()" aria-label="Continue." class="btn btn-secondary pull-right"> {{pageContent.buttons.submit}} </button>
                <a href="javascript:void(0)" (click)="backToCallingPage()" class="btn btn-link btn-block btn-cancel btnCancel"> {{pageContent.buttons.back}} </a>
            </div>
        </div>
    </div>
</div>
</main>
